import { FunctionComponent, useState } from 'react';

import { WorklistViewModel } from 'models';

import { useBoolean } from 'core/hooks';

import { WorklistEditModal } from './WorklistEditModal';
import { WorklistGridViewer } from './WorklistGridViewer';

export type WorklistManagementPageProps = {
  worklists: WorklistViewModel[];
  isLoading?: boolean;
  onUpdateWorklist: (worklist: WorklistViewModel) => void;
  onDeleteWorklist?: (worklist: WorklistViewModel) => void;
  onRefresh?: () => void;
};

export const WorklistManagementPage: FunctionComponent<WorklistManagementPageProps> = ({
  worklists,
  isLoading = false,
  onUpdateWorklist,
  onDeleteWorklist,
  onRefresh,
}) => {
  const [selectedWorklist, setSelectedWorklist] = useState<WorklistViewModel | null>(null);
  const [showEditModal, { setTrue: openEditModal, setFalse: closeEditModal }] = useBoolean(false);

  const handleEditWorklist = (worklist: WorklistViewModel) => {
    setSelectedWorklist(worklist);
    openEditModal();
  };

  const handleSaveWorklist = (updatedWorklist: WorklistViewModel) => {
    onUpdateWorklist(updatedWorklist);
    closeEditModal();
    setSelectedWorklist(null);
  };

  const handleCloseModal = () => {
    closeEditModal();
    setSelectedWorklist(null);
  };

  return (
    <>
      <WorklistGridViewer
        worklists={worklists}
        isLoading={isLoading}
        onEditWorklist={handleEditWorklist}
        onDeleteWorklist={onDeleteWorklist}
        onRefresh={onRefresh}
      />

      {showEditModal && selectedWorklist && <WorklistEditModal worklist={selectedWorklist} onClose={handleCloseModal} onSave={handleSaveWorklist} />}
    </>
  );
};
